export const BUY_IT_AGAIN_TAB = 'buyItAgain';
export const ORDER_HISTORY_TAB = 'orderHistory';
